import { createContext } from 'react';
import { ReactNode } from 'react';
import { useState } from 'react';

interface BannerContextType {
    bannerRef: HTMLDivElement | null;
    setBannerRef: (value: HTMLDivElement | null) => void;
}

export const BannerContext = createContext<BannerContextType>({} as BannerContextType);

export const BannerContextProvider = ({ children }: { children: ReactNode }) => {
    const [bannerRef, setBannerRef] = useState<HTMLDivElement | null>(null);
    return (
        <BannerContext.Provider value={{ bannerRef, setBannerRef }}>
            {children}
        </BannerContext.Provider>
    );
};
